import React from 'react';
import Backend from '../../../../Layouts/Backend';
import {
  FormGroup,
  Label,
  Input as ReactstrapInput,
  FormFeedback,
} from 'reactstrap';
import { Formik, Field } from 'formik';
import { validationSchema } from './validation';
import { withTranslation } from 'react-i18next';
import {
  Input,
  Dropdown,
  Checkbox,
  Button,
  Alert,
} from '../../../../UI/Common';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import ReactSelect from '../../../../UI/ReactSelect';

const alarmDelayTypes = [
  { value: false, label: 'Time (sec)' },
  { value: true, label: 'Updates' },
];
const dataTypes = [
  { value: false, label: 'Analog' },
  { value: true, label: 'Digital' },
];

const NewSensorTypePage = (props) => {
  const { t, units, isSubmitting } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onCreateSensorType(values);
    }
  }
  return (
    <Backend>
      <Formik
        enableReinitialize
        initialValues={props.form}
        validationSchema={validationSchema}
        onSubmit={(values) => onSubmit(values)}
      >
        {({
          values,
          handleChange,
          errors,
          setFieldTouched,
          touched,
          handleSubmit,
          setFieldValue,
        }) => {
          return (
            <div className="content-inner h-100">
              <PasswordConfirmation
                isOpen={openModal}
                onCancel={() => setOpenModal(false)}
                onConfirm={() => {
                  setOpenModal(false);
                  props.onCreateSensorType(values);
                }}
              />
              <div className="stacks h-100 sensor-type-setting custom-stacks">
                <Stack>
                  <Input
                    required
                    id="typeName"
                    label="Type Name"
                    onChange={handleChange('typeName')}
                    value={values.typeName}
                    invalid={touched.typeName}
                    error={errors.typeName}
                  />
                  <Dropdown
                    type="dynamic"
                    required
                    translated
                    label="Type of Alarm Delay"
                    data={alarmDelayTypes}
                    value={values.alarmDelayType}
                    onChange={({ value }) => {
                      setFieldTouched('alarmDelayType', false);
                      setFieldValue('alarmDelayType', value);
                    }}
                    valueKey="value"
                    nameKey="label"
                  />
                  <Input
                    required
                    id="alarmDelay"
                    label="Alarm Delay Setting"
                    onChange={handleChange('alarmDelay')}
                    value={values.alarmDelay}
                    invalid={touched.alarmDelay}
                    error={errors.alarmDelay}
                  />
                  <Dropdown
                    type="dynamic"
                    required
                    translated
                    label="Data Type"
                    data={dataTypes}
                    value={values.dataType}
                    onChange={({ value }) => {
                      setFieldTouched('dataType', false);
                      setFieldValue('dataType', value);
                    }}
                    valueKey="value"
                    nameKey="label"
                  />
                  <Input
                    required
                    id="decimalPrecision"
                    label="Decimal Precision"
                    onChange={handleChange('decimalPrecision')}
                    value={values.decimalPrecision}
                    invalid={touched.decimalPrecision}
                    error={errors.decimalPrecision}
                  />
                  <ReactSelect
                    required
                    label="Units"
                    options={units}
                    keyField="id"
                    value={values.units}
                    onChange={({ value }) => {
                      setFieldTouched('units', false);
                      setFieldValue('units', value);
                    }}
                    valueKey="units"
                    labelKey="units"
                    getOptionLabel={(obj) => (
                      <div>
                        <p style={{ marginTop: 0, marginBottom: '0.5rem' }}>
                          {obj.label}
                        </p>
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: '0.5rem',
                            fontSize: '0.75rem',
                            fontStyle: 'italic',
                          }}
                        >
                          {obj.description}
                        </p>
                      </div>
                    )}
                    invalid={touched.units}
                    error={errors.units}
                  />
                  <Input
                    id="parameter"
                    label="Parameter"
                    onChange={handleChange('parameter')}
                    value={values.parameter}
                    invalid={touched.parameter}
                    error={errors.parameter}
                  />
                  <Input
                    id="commLossTime"
                    label="Comm Loss Time (Min)"
                    onChange={handleChange('commLossTime')}
                    value={values.commLossTime}
                    invalid={touched.commLossTime}
                    error={errors.commLossTime}
                  />
                  <Input
                    id="chartMin"
                    label="Chart Min."
                    onChange={handleChange('chartMin')}
                    value={values.chartMin}
                    invalid={touched.chartMin}
                    error={errors.chartMin}
                  />
                  <Input
                    id="chartMax"
                    label="Chart Max."
                    onChange={handleChange('chartMax')}
                    value={values.chartMax}
                    invalid={touched.chartMax}
                    error={errors.chartMax}
                  />
                  <Checkbox
                    id="includeInBatchReports"
                    label="Include in Batch Reports"
                    checked={values.includeInBatchReports}
                    onChange={(isCheck) =>
                      setFieldValue('includeInBatchReports', isCheck)
                    }
                  />
                </Stack>
                <Stack className="px-30">
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '40% 30% 30%',
                      gridColumnGap: 10,
                    }}
                  >
                    <div className="d-inline-block align-top mt-35">
                      <TranslatedLabel
                        label="Low Alarm (<<)"
                        invalid={
                          errors.lowAlarmInOperation &&
                          touched.lowAlarmInOperation
                        }
                      />
                      <TranslatedLabel
                        label="Low Warning (<)"
                        invalid={
                          errors.lowWarningInOperation &&
                          touched.lowWarningInOperation
                        }
                      />
                      <TranslatedLabel
                        label="High Warning (>)"
                        invalid={
                          errors.highWarningInOperation &&
                          touched.highWarningInOperation
                        }
                      />
                      <TranslatedLabel
                        label="High Alarm (>>)"
                        invalid={
                          errors.highAlarmInOperation &&
                          touched.highAlarmInOperation
                        }
                      />
                      <TranslatedLabel
                        label="Normal Log Time (sec)"
                        invalid={
                          errors.normalLogTimeInOperation &&
                          touched.normalLogTimeInOperation
                        }
                      />
                      <TranslatedLabel
                        label="Alarm Log Time (sec)"
                        invalid={
                          errors.alarmTimeInOperation &&
                          touched.alarmTimeInOperation
                        }
                      />
                    </div>
                    <div className="d-inline-block align-top">
                      <Label className="sensor-type custom-label">
                        {t('In Operation')}
                      </Label>
                      <div className="wrapper-box">
                        <FieldWrapper id="lowAlarmInOperation" />
                        <FieldWrapper id="lowWarningInOperation" />
                        <FieldWrapper id="highWarningInOperation" />
                        <FieldWrapper id="highAlarmInOperation" />
                        <FieldWrapper id="normalLogTimeInOperation" />
                        <FieldWrapper id="alarmTimeInOperation" />
                      </div>
                    </div>
                    <div className="d-inline-block align-top">
                      <Label className="sensor-type custom-label">
                        {t('At Rest')}
                      </Label>
                      <div className="wrapper-box">
                        <FieldWrapper id="lowAlarmAtRest" />
                        <FieldWrapper id="lowWarningAtRest" />
                        <FieldWrapper id="highWarningAtRest" />
                        <FieldWrapper id="highAlarmAtRest" />
                        <FieldWrapper id="normalLogTimeAtRest" />
                        <FieldWrapper id="alarmLogTimeAtRest" />
                      </div>
                    </div>
                  </div>
                </Stack>
                <Stack>
                  <ReactSelect
                    required
                    label="Calc. Units"
                    options={units}
                    keyField="id"
                    value={values.chartUnits}
                    onChange={({ value }) => {
                      setFieldTouched('chartUnits', false);
                      setFieldValue('chartUnits', value);
                    }}
                    valueKey="units"
                    labelKey="units"
                    getOptionLabel={(obj) => (
                      <div>
                        <p style={{ marginTop: 0, marginBottom: '0.5rem' }}>
                          {obj.label}
                        </p>
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: '0.5rem',
                            fontSize: '0.75rem',
                            fontStyle: 'italic',
                          }}
                        >
                          {obj.description}
                        </p>
                      </div>
                    )}
                  />
                  <Input
                    required
                    id="calcDecimalPrecision"
                    label="Calc DP"
                    onChange={handleChange('calcDecimalPrecision')}
                    value={values.calcDecimalPrecision}
                    invalid={touched.calcDecimalPrecision}
                    error={errors.calcDecimalPrecision}
                  />
                  <Input
                    id="calcChartMin"
                    label="Calc Chart Min."
                    onChange={handleChange('calcChartMin')}
                    value={values.calcChartMin}
                    invalid={errors.calcChartMin && touched.calcChartMin}
                    error={errors.calcChartMin}
                  />
                  <Input
                    id="calcChartMax"
                    label="Calc Chart Max."
                    onChange={handleChange('calcChartMax')}
                    value={values.calcChartMax}
                    invalid={touched.calcChartMax}
                    error={errors.calcChartMax}
                  />
                </Stack>
              </div>
              <Alert.Error text={props.errors} />
              <Button
                id="new-sensor-type-btn"
                classes="my-10"
                loading={isSubmitting}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
                disabled={isSubmitting}
              >
                {t('Save')}
              </Button>
            </div>
          );
        }}
      </Formik>
    </Backend>
  );
};

export default withTranslation('app')(NewSensorTypePage);

export const Stack = (props) => (
  <div
    className={`stack-wrapper pt-3 ${props.className ? props.className : ''}`}
  >
    <div className="stack">
      <div className="stack-inner">{props.children}</div>
    </div>
  </div>
);

const CustomLabel = ({ t, label, invalid, id }) => (
  <Label
    className={invalid ? 'mb-50' : 'mb-30'}
    style={{
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }}
    htmlFor={id}
  >
    {t(label)}
  </Label>
);

export const TranslatedLabel = withTranslation('app')(CustomLabel);

const CustomInput = ({
  field,
  form: { values, handleChange, touched, errors },
  id,
  t,
  ...props
}) => (
  <FormGroup>
    <ReactstrapInput
      id={id}
      value={values[id]}
      onChange={handleChange(id)}
      invalid={errors[id] && touched[id] ? true : false}
    />
    {touched[id] && errors[id] && <FormFeedback>{t(errors[id])}</FormFeedback>}
  </FormGroup>
);

export const TranslatedInput = withTranslation('app')(CustomInput);

const FieldWrapper = (props) => (
  <Field {...props} component={TranslatedInput} />
);
